import i18n from '@/i18n'
import { mapActions } from 'vuex'
import ScoringDialogFirstLevelTabComponent from './tabs/first-level/ScoringDialogFirstLevelTabComponent.vue'
import ScoringDialogSecondLevelTabComponent from './tabs/second-level/ScoringDialogSecondLevelTabComponent.vue'
import ScoringDialogThirdLevelTabComponent from './tabs/third-level/ScoringDialogThirdLevelTabComponent.vue'
import Vue from 'vue'
import { EventHub } from "@/constants/constants"
import { DialogScoring } from '@/tools/dialog'
import { mapGetters } from "vuex"
import moment from 'moment'
import { clone } from 'ramda'

export default {
    name: 'ScoringDialogComponent',
    components: {
        ScoringDialogFirstLevelTabComponent,
        ScoringDialogSecondLevelTabComponent,
        ScoringDialogThirdLevelTabComponent
    },
    props: {
        // v-model injects the object to be edited into props.value
        model: {
            type: Object,
            required: true
        }
    },
    data: () => ({
        // tab seleccionada
        tab: null,
        // modelos de los tabs
        items: [
            {
                key: 'scoringDialogFirstLevelTab',
                tab: i18n.t('scoring.editDialog.tabs.level', { number: 1 }),
                tooltip: i18n.t('scoring.editDialog.tabs.levelTooltip', { number: 1 }),
                icon: 'mdi-numeric-1-box-outline',
                content: {
                    _uid: 'SGTtsnA1iz',
                    component: 'ScoringDialogFirstLevelTabComponent',
                    headline: 'ScoringDialogFirstLevelTabComponent'
                },
                model: {
                    firstLevel: [],
                    showForm: false
                },
                validForm: false
            },
            {
                key: 'scoringDialogScondLevelTab',
                tab: i18n.t('scoring.editDialog.tabs.level', { number: 2 }),
                tooltip: i18n.t('scoring.editDialog.tabs.levelTooltip', { number: 2 }),
                icon: 'mdi-numeric-2-box-outline',
                content: {
                    _uid: '6eiDFVsdK3',
                    component: 'ScoringDialogSecondLevelTabComponent',
                    headline: 'ScoringDialogSecondLevelTabComponent'
                },
                model: {
                    timeWindow: null,
                    hardBraking: {
                        sligth: {
                            range: {
                                min: null,
                                max: null
                            },
                            weightedValue: null
                        },
                        medium: {
                            range: {
                                min: null,
                                max: null,
                            },
                            weightedValue: null
                        },
                        serious: {
                            range: {
                                min: null,
                                max: null,
                            },
                            weightedValue: null
                        }
                    },
                    acceleration: {
                        sligth: {
                            range: {
                                min: null,
                                max: null
                            },
                            weightedValue: null
                        },
                        medium: {
                            range: {
                                min: null,
                                max: null,
                            },
                            weightedValue: null
                        },
                        serious: {
                            range: {
                                min: null,
                                max: null,
                            },
                            weightedValue: null
                        }
                    },
                    corneringAcceleration: {
                        sligth: {
                            range: {
                                min: null,
                                max: null
                            },
                            weightedValue: null
                        },
                        medium: {
                            range: {
                                min: null,
                                max: null,
                            },
                            weightedValue: null
                        },
                        serious: {
                            range: {
                                min: null,
                                max: null,
                            },
                            weightedValue: null
                        }
                    },
                    disconnection: {
                        sligth: {
                            range: {
                                min: null,
                                max: null
                            },
                            weightedValue: null
                        },
                        medium: {
                            range: {
                                min: null,
                                max: null,
                            },
                            weightedValue: null
                        },
                        serious: {
                            range: {
                                min: null,
                                max: null,
                            },
                            weightedValue: null
                        }
                    },
                    showForm: false
                },
                validForm: false
            },
            {
                key: 'scoringDialogThirdLevelTab',
                tab: i18n.t('scoring.editDialog.tabs.level', { number: 3 }),
                tooltip: i18n.t('scoring.editDialog.tabs.levelTooltip', { number: 3 }),
                icon: 'mdi-numeric-3-box-outline',
                content: {
                    _uid: '8bF4ObHlS7',
                    component: 'ScoringDialogThirdLevelTabComponent',
                    headline: 'ScoringDialogThirdLevelTabComponent'
                },
                model: {
                    maxStopTime: null,
                    nightSchedule: {
                        start: null,
                        end: null
                    },
                    ralenti: {
                        sligth: {
                            range: {
                                min: null,
                                max: null
                            },
                            weightedValue: null
                        },
                        medium: {
                            range: {
                                min: null,
                                max: null,
                            },
                            weightedValue: null
                        },
                        serious: {
                            range: {
                                min: null,
                                max: null,
                            },
                            weightedValue: null
                        }
                    },
                    continuousDriving: {
                        sligth: {
                            range: {
                                min: null,
                                max: null
                            },
                            weightedValue: null
                        },
                        medium: {
                            range: {
                                min: null,
                                max: null,
                            },
                            weightedValue: null
                        },
                        serious: {
                            range: {
                                min: null,
                                max: null,
                            },
                            weightedValue: null
                        }
                    },
                    nightDriving: {
                        sligth: {
                            range: {
                                min: null,
                                max: null
                            },
                            weightedValue: null
                        },
                        medium: {
                            range: {
                                min: null,
                                max: null,
                            },
                            weightedValue: null
                        },
                        serious: {
                            range: {
                                min: null,
                                max: null,
                            },
                            weightedValue: null
                        }
                    },
                    incompleteRest: {
                        sligth: {
                            range: {
                                min: null,
                                max: null
                            },
                            weightedValue: null
                        },
                        medium: {
                            range: {
                                min: null,
                                max: null,
                            },
                            weightedValue: null
                        },
                        serious: {
                            range: {
                                min: 0,
                                max: null,
                            },
                            weightedValue: null
                        }
                    },
                    showForm: false
                },
                validForm: false
            }
        ],
        // reglas de validación
        validationRules: {
            required: (value) => !!value || value === 0 || `${i18n.t('required')}`,
            lessThan: (value, maxValue) => value == null || maxValue == null || Number(value) < Number(maxValue) || `${i18n.t('error.lessThan', { value: maxValue })}`,
            moreThan: (value, minValue) => value == null || minValue == null || Number(value) > Number(minValue) || `${i18n.t('error.moreThan', { value: minValue })}`,
            greaterThanEqual: (value, minValue) => value == null || minValue == null || Number(value) >= Number(minValue) || `${i18n.t('error.greaterThanEqual', { value: minValue })}`,
            timeAfter: (valueAfter, valueBefore) => {
                if (!valueAfter || !valueBefore) {
                    return true
                } else {
                    const firstTime = moment(valueBefore, 'HH:mm')
                    const secondTime = moment(valueAfter, 'HH:mm')
                    // para validar horas que cambian de día (ejemplo: de 20:00 PM a 5:00 AM)
                    if ((firstTime.hour() >= 12 && secondTime.hour() <= 12) || secondTime.isBefore(firstTime)) {
                        secondTime.add(1, "days");
                    }
                    return secondTime.isAfter(firstTime) || i18n.t('error.timeAfter', { time: valueBefore })
                }
            }
        },
        // para mostrar / ocultar el dialog de edición
        showEditDialog: false,
        // título del dialog
        editDialogTitle: i18n.t('scoring.edit'),
        // flag para resetear validaciones en los formularios
        resetForms: false,
        // modo vista
        viewMode: false,
        // indica si se está actualizando una empresa
        update: false
    }),
    computed: {
        ...mapGetters({
            'getBread': 'breadcrumbs/getBread',
        }),
        /**
         * Validación de completitud de los niveles 2 y 3
         */
        levelsValidation() {
            const secondLevelInfractions = ['hardBraking', 'acceleration', 'corneringAcceleration', 'disconnection']
            const thirdLevelInfractions = ['ralenti', 'continuousDriving', 'nightDriving', 'incompleteRest']
            const ranges = ['sligth', 'medium', 'serious']

            let secondLevelValidation = true
                && this.items[1].model.timeWindow != null
            let i = 0
            while (i < secondLevelInfractions.length && secondLevelValidation) {
                let r = 0
                while (r < ranges.length && secondLevelValidation) {
                    secondLevelValidation = secondLevelValidation
                        && this.items[1].model[secondLevelInfractions[i]][ranges[r]].range.min != null
                        && ((this.items[1].model[secondLevelInfractions[i]][ranges[r]].range.max != null) || (ranges[r] === 'serious' && (this.items[1].model[secondLevelInfractions[i]][ranges[r]].range.max == null)))
                        && this.items[1].model[secondLevelInfractions[i]][ranges[r]].weightedValue != null
                    r++
                }
                i++
            }

            let thirdLevelValidation = true
                && this.items[2].model.maxStopTime != null
                && this.items[2].model.nightSchedule.start != null
                && this.items[2].model.nightSchedule.end != null
            let j = 0
            while (j < thirdLevelInfractions.length && thirdLevelValidation) {
                let r = 0
                while (r < ranges.length && thirdLevelValidation) {
                    if (thirdLevelInfractions[j] !== 'incompleteRest') {
                        thirdLevelValidation = thirdLevelValidation
                            && this.items[2].model[thirdLevelInfractions[j]][ranges[r]].range.min != null
                            && ((this.items[2].model[thirdLevelInfractions[j]][ranges[r]].range.max != null) || (ranges[r] === 'serious' && (this.items[2].model[thirdLevelInfractions[j]][ranges[r]].range.max == null)))
                            && this.items[2].model[thirdLevelInfractions[j]][ranges[r]].weightedValue != null
                    } else {
                        thirdLevelValidation = thirdLevelValidation
                            && this.items[2].model[thirdLevelInfractions[j]][ranges[r]].range.min != null
                            && this.items[2].model[thirdLevelInfractions[j]][ranges[r]].range.max != null
                            && this.items[2].model[thirdLevelInfractions[j]][ranges[r]].weightedValue != null
                    }
                    r++
                }
                j++
            }

            return secondLevelValidation && thirdLevelValidation
        }
    },
    created() {
        /**
         * El modelo de datos del diálogo se carga a través del objeto del breadcrumb
         */
        this.unwatch = this.$store.watch(
            (state, getters) => getters['breadcrumbs/getBread'],
            (newBreads) => {
                const lastBreadcrumb = this.getBread[newBreads.length - 1]
                if (!lastBreadcrumb) {
                    this.cancel()
                } else {
                    if (lastBreadcrumb.key === DialogScoring) {
                        if (lastBreadcrumb.model) {
                            const modelData = this.model
                            Object.assign(modelData, lastBreadcrumb.model)
                        }
                        if (lastBreadcrumb.tab) {
                            this.tab = lastBreadcrumb.tab
                        }
                        this.viewMode = lastBreadcrumb.view
                        this.update = lastBreadcrumb.update
                    }
                }
            },
            { deep: true })
    },
    mounted() {
        const lastBreadcrumb = this.getBread[this.getBread.length - 1]
        if (!lastBreadcrumb) {
            this.cancel()
        } else {
            if (lastBreadcrumb.key === DialogScoring) {
                if (lastBreadcrumb.model) {
                    const modelData = this.model
                    Object.assign(modelData, lastBreadcrumb.model)
                }
                if (lastBreadcrumb.tab) {
                    this.tab = lastBreadcrumb.tab
                }
                this.viewMode = lastBreadcrumb.view
                this.update = lastBreadcrumb.update
            }
        }
    },
    beforeDestroy() {
        // elimino la instancia del watcher del breadcrumb
        this.unwatch()
    },
    methods: {
        /**
         * actions del snackbar
         */
        ...mapActions('snackbar', [
            'showSnackbar',
            'closeSnackbar'
        ]),
        /**
         * actions del dialog
         */
        ...mapActions('dialog', [
            'openDialog',
            'closeDialog'
        ]),
        /**
         * actions del breadcrumb
         */
        ...mapActions('breadcrumbs', [
            'pullBread'
        ]),
        /**
         * Resetea los campos del formulario de creación/actualización
         */
        resetFields() {
            if (this.update) {
                const model = clone(this.model)
                this.items[0].model.firstLevel = model.firstLevel
                this.items[0].model.showForm = false

                this.items[1].model.timeWindow = model.secondLevel.timeWindow
                this.items[1].model.hardBraking = model.secondLevel.hardBraking
                this.items[1].model.acceleration = model.secondLevel.acceleration
                this.items[1].model.corneringAcceleration = model.secondLevel.corneringAcceleration
                this.items[1].model.disconnection = model.secondLevel.disconnection
                this.items[1].model.showForm = false

                this.items[2].model.maxStopTime = model.thirdLevel.maxStopTime
                this.items[2].model.nightSchedule.start = model.thirdLevel.nightSchedule.start
                this.items[2].model.nightSchedule.end = model.thirdLevel.nightSchedule.end
                this.items[2].model.ralenti = model.thirdLevel.ralenti
                this.items[2].model.continuousDriving = model.thirdLevel.continuousDriving
                this.items[2].model.nightDriving = model.thirdLevel.nightDriving
                this.items[2].model.incompleteRest = model.thirdLevel.incompleteRest
                this.items[2].model.showForm = false
                this.items[2].model.timezone = model.thirdLevel.timezone;
            } else {
                this.items[0].model.firstLevel = []
                this.items[0].model.showForm = false

                this.items[1].model.timeWindow = null
                this.items[1].model.hardBraking = {
                    sligth: {
                        range: {
                            min: null,
                            max: null
                        },
                        weightedValue: null
                    },
                    medium: {
                        range: {
                            min: null,
                            max: null,
                        },
                        weightedValue: null
                    },
                    serious: {
                        range: {
                            min: null,
                            max: null,
                        },
                        weightedValue: null
                    }
                }
                this.items[1].model.acceleration = {
                    sligth: {
                        range: {
                            min: null,
                            max: null
                        },
                        weightedValue: null
                    },
                    medium: {
                        range: {
                            min: null,
                            max: null,
                        },
                        weightedValue: null
                    },
                    serious: {
                        range: {
                            min: null,
                            max: null,
                        },
                        weightedValue: null
                    }
                }
                this.items[1].model.corneringAcceleration = {
                    sligth: {
                        range: {
                            min: null,
                            max: null
                        },
                        weightedValue: null
                    },
                    medium: {
                        range: {
                            min: null,
                            max: null,
                        },
                        weightedValue: null
                    },
                    serious: {
                        range: {
                            min: null,
                            max: null,
                        },
                        weightedValue: null
                    }
                }
                this.items[1].model.disconnection = {
                    sligth: {
                        range: {
                            min: null,
                            max: null
                        },
                        weightedValue: null
                    },
                    medium: {
                        range: {
                            min: null,
                            max: null,
                        },
                        weightedValue: null
                    },
                    serious: {
                        range: {
                            min: null,
                            max: null,
                        },
                        weightedValue: null
                    }
                }
                this.items[1].model.showForm = false

                this.items[2].model.maxStopTime = null
                this.items[2].model.nightSchedule = {
                    start: null,
                    end: null
                }
                this.items[2].model.ralenti = {
                    sligth: {
                        range: {
                            min: null,
                            max: null
                        },
                        weightedValue: null
                    },
                    medium: {
                        range: {
                            min: null,
                            max: null,
                        },
                        weightedValue: null
                    },
                    serious: {
                        range: {
                            min: null,
                            max: null,
                        },
                        weightedValue: null
                    }
                }
                this.items[2].model.continuousDriving = {
                    sligth: {
                        range: {
                            min: null,
                            max: null
                        },
                        weightedValue: null
                    },
                    medium: {
                        range: {
                            min: null,
                            max: null,
                        },
                        weightedValue: null
                    },
                    serious: {
                        range: {
                            min: null,
                            max: null,
                        },
                        weightedValue: null
                    }
                }
                this.items[2].model.nightDriving = {
                    sligth: {
                        range: {
                            min: null,
                            max: null
                        },
                        weightedValue: null
                    },
                    medium: {
                        range: {
                            min: null,
                            max: null,
                        },
                        weightedValue: null
                    },
                    serious: {
                        range: {
                            min: null,
                            max: null,
                        },
                        weightedValue: null
                    }
                }
                this.items[2].model.incompleteRest = {
                    sligth: {
                        range: {
                            min: null,
                            max: null
                        },
                        weightedValue: null
                    },
                    medium: {
                        range: {
                            min: null,
                            max: null,
                        },
                        weightedValue: null
                    },
                    serious: {
                        range: {
                            min: 0,
                            max: null,
                        },
                        weightedValue: null
                    }
                }
                this.items[2].model.showForm = false
            }

            // para limpiar las validaciones en los formularios
            this.resetForms = true
            const that = this
            Vue.nextTick(function () {
                that.resetForms = false
            })
        },
        /**
         * Click fuera del dialog
         */
        clickOutside() {
            this.cancel()
        },
        /**
         * Cancelar
         */
        cancel() {
            this.pullBread(DialogScoring)
            if (!this.viewMode) {
                this.resetFields()
            }
        },
        /**
         * Guardar
         */
        save() {
            const scoringConfiguration = this.getScoringConfiguration()
            this.cancel()
            this.$eventBus.$emit(EventHub.COMMIT_SCORING_CONFIGURATION, scoringConfiguration)
        }, 
        /**
         * Genera el objeto que se guarda en la empresa
         */

        getScoringConfiguration() {
            const nightScheduleStart = this.items[2].model.nightSchedule.start
            const nightScheduleEnd = this.items[2].model.nightSchedule.end
            const scoringConfiguration = {
                firstLevel: this.items[0].model.firstLevel,
                secondLevel: {
                    timeWindow: this.items[1].model.timeWindow,
                    hardBraking: this.items[1].model.hardBraking,
                    acceleration: this.items[1].model.acceleration,
                    corneringAcceleration: this.items[1].model.corneringAcceleration,
                    disconnection: this.items[1].model.disconnection
                },
                thirdLevel: {
                    timezone: this.items[2].model.timezone,
                    maxStopTime: this.items[2].model.maxStopTime,
                    nightSchedule: {
                        start: nightScheduleStart,
                        end: nightScheduleEnd
                    },
                    ralenti: this.items[2].model.ralenti,
                    continuousDriving: this.items[2].model.continuousDriving,
                    nightDriving: this.items[2].model.nightDriving,
                    incompleteRest: this.items[2].model.incompleteRest
                }
            }
            return scoringConfiguration
        },
        /**
         * Retorna un boolean para habilitar / deshabilitar el botón save
         */
        disableSaveBtn() {
            return !this.items[1].validForm || !this.items[2].validForm || !this.levelsValidation
        }
    },
    watch: {
        model: {
            deep: true,
            immediate: true,
            handler: function (newModel) {
                if (newModel) {
                    const model = clone(newModel)
                    this.items[0].model.firstLevel = model.firstLevel

                    this.items[1].model.timeWindow = model.secondLevel.timeWindow
                    this.items[1].model.hardBraking = model.secondLevel.hardBraking
                    this.items[1].model.acceleration = model.secondLevel.acceleration
                    this.items[1].model.corneringAcceleration = model.secondLevel.corneringAcceleration
                    this.items[1].model.disconnection = model.secondLevel.disconnection

                    this.items[2].model.maxStopTime = model.thirdLevel.maxStopTime
                    this.items[2].model.nightSchedule = model.thirdLevel.nightSchedule
                    this.items[2].model.ralenti = model.thirdLevel.ralenti
                    this.items[2].model.continuousDriving = model.thirdLevel.continuousDriving
                    this.items[2].model.nightDriving = model.thirdLevel.nightDriving
                    this.items[2].model.incompleteRest = model.thirdLevel.incompleteRest
                    this.items[2].model.timezone = model.thirdLevel.timezone
                }
            }
        }
    }
}
